import { Component } from '@angular/core';

@Component({
  selector: 'app-client-ticket',
  templateUrl: './client-ticket.component.html',
  styleUrls: ['./client-ticket.component.scss'],
})
export class ClientTicketComponent {}
